export const ANSWER_HEADER_ID = "AnswerHeaderId";
export const ANSWER_HEADER_ANSWERS_ID = "AnswerHeaderAnswersId";
export const ANSWER_HEADER_COUNT_ID = "AnswerHeaderCountId";
